export default "__VITE_ASSET__8dcbca96__"